import { Tab, TabList, TabPanels, Tabs } from "@carbon/react";
import React from "react";
import { Outlet } from "react-router-dom";

import PageHeader from "src/components/PageHeader.tsx";
import PageStack from "src/components/PageStack/PageStack.tsx";
import { useTabNavigation } from "src/components/TabbedView/useTabNavigation.ts";
import { useT } from "src/internationalization";
import { mapToCaseTabs } from "src/mappers/case.mappers";
import { useCaseTypes } from "src/providers/CaseTypesProvider";

const RulesPage: React.FC = () => {
  const t = useT();

  const { caseTypes } = useCaseTypes();

  const tabs = caseTypes.map((caseType) => mapToCaseTabs(caseType));

  const { navigateTab, selectedTab } = useTabNavigation({
    tabs,
    pathPrefix: "/rules",
  });

  const onTabChange = (state: { selectedIndex: number }) => navigateTab(state.selectedIndex);
  return (
    <PageStack>
      <div className="flex justify-between">
        <PageHeader>{t("rules.title")}</PageHeader>
      </div>
      <Tabs selectedIndex={selectedTab?.index ?? 0} onChange={onTabChange}>
        <TabList aria-label="List of tabs">
          {tabs.map((tab) => (
            <Tab key={tab.code}>{tab.label}</Tab>
          ))}
        </TabList>
        <TabPanels>
          <div className="mt-5">
            <Outlet />
          </div>
        </TabPanels>
      </Tabs>
    </PageStack>
  );
};

export default RulesPage;
